import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { SidebarService } from '../providers/sidebar.service';
import { AuthService } from '../providers/auth.service';
import { TranslocoDirective} from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { DbService } from '../providers/db.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UserInterface } from '../interfaces';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})

export class SidebarComponent implements OnInit {
  public db = inject(DbService);
  public auth = inject(AuthService);
  public sb = inject(SidebarService);

  user: UserInterface = undefined;
  newUser = true;
  help = 'no need';
  showSpinner = true;
  dropdownPosition = 'bottom-right';
  tooltipPosition = 'bottom';
  sideBarSize = '';

  num = 0;
  trans = 'menu.selection-accounts-tooltip';

  public isCollapsed = true;

  visible = true;
  @Output() opener: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closer: EventEmitter<boolean> = new EventEmitter<boolean>();



  ngOnInit() {
    this.sideBarSize = this.sb.currentSidebarSize();
    this.auth.user$.subscribe(() => {
      this.showSpinner = false;
    })
  }


  sideBarCollapser(size: string) {
    const result = this.sb.toggleSidebarSize(size);
    if (result) { this.sideBarSize = this.sb.currentSidebarSize(); }
  }

  async LogoutCheck() {
    await this.auth.signOutAsync();
    this.user = null;
  }
}

